import { FormattedMessage } from "react-intl";
import { Divider, ExclamationCircleIcon, Flex, IconBtn, PasteIcon, Text } from "@paguelofacil/pf-components";
import { QRCode } from "react-qrcode-logo";

import { language, languageDefault } from "../../services/utils/Language";
import useStore from "../../services/store/useStore";
import { formattedDate } from "../../utils/helpers";

import ImgCryptofacilQr from "../../assets/images/ImgCryptofacilQr.svg";

export const TransactionInformation = () => {
    const receiveData = useStore(state => state.receiveData);

    const afterTenMinutes = new Date(receiveData.date.getTime() + 10 * 60 * 1000);

    return (
        <Flex direction="column" gap="1rem">
            <Flex direction="column" className="container-info-payment">
                <div className="container-warning-time-freeze">
                    <Text variant="caption" color="#515A69" weight="regular">
                        <FormattedMessage
                            id={language.warning_time_freeze}
                            defaultMessage={languageDefault.warning_time_freeze}
                            values={{
                                date: (
                                    <Text variant="body6" color="#3D444F" style={{ display: "inline" }}>
                                        {formattedDate(afterTenMinutes, true)}
                                    </Text>
                                ),
                            }}
                        />
                    </Text>
                </div>
                <Flex direction="row" wrap="nowrap" justify="space-between" gap="0.25rem">
                    <Text variant="body6" weight="regular" color="#3b3b3c">
                        <FormattedMessage id={language.date_hour} defaultMessage={languageDefault.date_hour} />:
                    </Text>{" "}
                    <Text variant="body6">{formattedDate(receiveData.date)}</Text>
                </Flex>
                <Divider />
                <QRCode
                    ecLevel="M"
                    eyeRadius={10}
                    qrStyle="dots"
                    logoImage={ImgCryptofacilQr}
                    logoWidth={40}
                    value={receiveData.address ? receiveData.address : ""}
                    quietZone={20}
                />
                <Flex direction="row" wrap="nowrap" justify="space-between" gap="0.25rem">
                    <Text variant="body6" weight="regular" color="#3D444F">
                        <FormattedMessage id={language.coin} defaultMessage={languageDefault.coin} />:
                    </Text>{" "}
                    <Text variant="body6">{receiveData.coin}</Text>
                </Flex>
                <Flex direction="row" wrap="nowrap" justify="space-between" gap="0.25rem">
                    <Text variant="body6" weight="regular" color="#3D444F">
                        <FormattedMessage id={language.network} defaultMessage={languageDefault.network} />:
                    </Text>{" "}
                    <Text variant="body6">{receiveData.network}</Text>
                </Flex>
                <Text
                    color="#515A69"
                    variant="caption"
                    weight="regular"
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        width: "100%",
                        gap: "0.25rem",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <ExclamationCircleIcon color="#EDB600" size="12" isFullfill />{" "}
                    </div>
                    <FormattedMessage
                        id={language.information_crypto_1}
                        defaultMessage={languageDefault.information_crypto_1}
                    />{" "}
                </Text>
                <Flex direction="row" justify="space-between" gap="0.25rem">
                    <Text variant="body6" weight="regular" color="#3D444F">
                        <FormattedMessage id={language.address} defaultMessage={languageDefault.address} />:
                    </Text>{" "}
                    <Text variant="body6" style={{ whiteSpace: "nowrap", maxWidth: "100%" }}>
                        {receiveData.address}{" "}
                        <IconBtn
                            variant="neutral"
                            handleClick={() => navigator.clipboard.writeText(receiveData.address)}
                        >
                            <PasteIcon />
                        </IconBtn>
                    </Text>
                </Flex>
            </Flex>
            <Divider />
            <Flex direction="column" align="center" justify="center" gap="1rem">
                <Text variant="body5">
                    <FormattedMessage
                        id={language.title_steps_recharge}
                        defaultMessage={languageDefault.title_steps_recharge}
                    />
                </Text>
                <div className="grid-steps-recharge">
                    <Flex
                        direction="row"
                        wrap="nowrap"
                        justify="start"
                        align="center"
                        className="step-one"
                        gap="0.5rem"
                    >
                        <div className="step-indicator">1</div>
                        <Text variant="body6" weight="regular" color="#3D444F">
                            <FormattedMessage
                                id={language.step_one_recharge}
                                defaultMessage={languageDefault.step_one_recharge}
                            />
                        </Text>
                    </Flex>
                    <Flex
                        direction="row"
                        wrap="nowrap"
                        justify="start"
                        align="center"
                        className="step-two"
                        gap="0.5rem"
                    >
                        <div className="step-indicator">2</div>
                        <Text variant="body6" weight="regular" color="#3D444F">
                            <FormattedMessage
                                id={language.step_two_recharge}
                                defaultMessage={languageDefault.step_two_recharge}
                            />
                        </Text>
                    </Flex>
                    <Flex
                        direction="row"
                        wrap="nowrap"
                        justify="start"
                        align="center"
                        className="step-three"
                        gap="0.5rem"
                    >
                        <div className="step-indicator">3</div>
                        <Text variant="body6" weight="regular" color="#3D444F">
                            <FormattedMessage
                                id={language.step_three_recharge}
                                defaultMessage={languageDefault.step_three_recharge}
                            />
                        </Text>
                    </Flex>
                    <Flex
                        direction="row"
                        wrap="nowrap"
                        justify="start"
                        align="center"
                        className="step-four"
                        gap="0.5rem"
                    >
                        <div className="step-indicator">4</div>
                        <Text variant="body6" weight="regular" color="#3D444F">
                            <FormattedMessage
                                id={language.step_four_recharge}
                                defaultMessage={languageDefault.step_four_recharge}
                            />
                        </Text>
                    </Flex>
                </div>
            </Flex>
            <Divider />
            <Flex direction="column" gap="0.25" align="flex-start" style={{ marginTop: "2rem" }}>
                <Flex direction="row" justify="space-between" gap="0.25rem" className="container-total-amount">
                    <Text variant="body6" weight="regular">
                        <FormattedMessage id={language.total} defaultMessage={languageDefault.total} />:
                    </Text>
                    <Flex direction="row" wrap="nowrap" align="flex-end" gap="0.25rem" width="auto" minW="auto">
                        <Text variant="body2" className="amount-total-recharge">
                            {receiveData.cryptoAmount}
                        </Text>
                        <Text variant="body6" className="coin-total-recharge">
                            {receiveData.coin || "USDT"}
                        </Text>
                    </Flex>
                </Flex>
            </Flex>
            <Text
                color="#515A69"
                variant="caption"
                weight="regular"
                style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    width: "100%",
                    gap: "0.25rem",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <ExclamationCircleIcon color="#EDB600" size="12" isFullfill />{" "}
                </div>
                <FormattedMessage
                    id={language.disclaimer_receive_two}
                    defaultMessage={languageDefault.disclaimer_receive_two}
                />{" "}
            </Text>
        </Flex>
    );
};
